<div class="d-flex flex-column">
  <img  loading="lazy"  *ngIf="!isTypePdf" [src]="lang == 'en' ? data?.en : data?.ar"    alt="image" />
  <iframe *ngIf="isTypePdf" width="auto" height="auto" type="application/pdf"
    [src]="(lang == 'en' ? data?.en : data?.ar) | safe"></iframe>
</div>
